import { UPDATE_FLEXI_REQUEST_STATUS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { UpdateFlexiRequestStatusPayload, UpdateFlexiRequestStatusResponse } from '../../types/flexi';

const updateFlexiRequestStatus = async (
  payload: UpdateFlexiRequestStatusPayload
): Promise<UpdateFlexiRequestStatusResponse> => {
  try {
    const { _id, ...body } = payload;
    const response = await makeAuthenticatedRequest(
      UPDATE_FLEXI_REQUEST_STATUS(_id),
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update flexi request status: ${response.statusText}`);
    }

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { updateFlexiRequestStatus };
